import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import ReportRoboImg from "../../../Assets/Images/report_robo.png";
import DAYS_LIST from "../../../Constants/DATA/daysList";
import MONTHS_LIST from "../../../Constants/DATA/monthsList";
import WEEKDAYS_LIST from "../../../Constants/DATA/weekDaysList";
import SendReport from "./SendReport";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
});

class AutoReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // freqList: [
      //     { displayvalue: 1, displayname: "Daily" },
      //     { displayvalue: 2, displayname: "Weekly" },
      //     { displayvalue: 3, displayname: "Monthly" },
      //     { displayvalue: 4, displayname: "Quaterly" },
      //     { displayvalue: 5, displayname: "Annualy" }
      // ],
      freq: { displayname: "Daily", displayvalue: 1 },
      daily: true,
      weekly: false,
      monthly: false,
      quaterly: false,
      annualy: false,
      showTime: true,
      weekList: WEEKDAYS_LIST,
      dayList: DAYS_LIST,
      monthList: MONTHS_LIST,
    };
  }

  componentDidMount() {
    if (this.props.updateId != null) {
      // this.getReportDataById()
      const freq = this.props.FrequencyType.find(
        (x) =>
          x.displayvalue == this.props.updateData.ReportData[0].frequencytypeid,
      );
      console.log("freq: didmount ", freq);
      this.setState(
        {
          freq,
          showTime: true,
          selectTime: `2019-01-28T${this.props.updateData.ReportData[0].scheduledtime}:00.000`,
        },
        () => {
          switch (this.props.updateData.ReportData[0].frequencytypeid) {
            case 1:
              this.setState(
                {
                  daily: true,
                  weekly: false,
                  monthly: false,
                  quaterly: false,
                  annualy: false,
                },
                () => {},
              );
              break;
            case 2:
              this.setState(
                {
                  daily: false,
                  weekly: true,
                  monthly: false,
                  quaterly: false,
                  annualy: false,
                },
                () => {
                  const selectedWeek = this.state.weekList.find(
                    (x) =>
                      x.displayvalue
                      == this.props.updateData.ReportData[0].frequencyvalue,
                  );
                  this.setState({
                    selectedWeek,
                    freqValue: selectedWeek.displayvalue,
                  });
                },
              );
              break;

            case 3:
              this.setState(
                {
                  daily: false,
                  weekly: false,
                  monthly: true,
                  quaterly: false,
                  annualy: false,
                },
                () => {
                  const selectedDay = this.state.dayList.find(
                    (x) =>
                      x.displayvalue
                      == this.props.updateData.ReportData[0].frequencyvalue,
                  );
                  this.setState({
                    selectedDay,
                    freqValue: selectedDay.displayvalue,
                  });
                },
              );
              break;
            case 4:
              this.setState(
                {
                  daily: false,
                  weekly: false,
                  monthly: false,
                  quaterly: true,
                  annualy: false,
                },
                () => {
                  const selectedMonth = this.state.monthList.find(
                    (x) =>
                      x.displayvalue
                      == this.props.updateData.ReportData[0].frequencyvalue,
                  );
                  this.setState({
                    selectedMonth,
                    freqValue: selectedMonth.displayvalue,
                  });
                },
              );
              break;
            case 6:
              this.setState(
                {
                  daily: false,
                  weekly: false,
                  monthly: false,
                  quaterly: false,
                  annualy: true,
                },
                () => {
                  const selectedMonth = this.state.monthList.find(
                    (x) =>
                      x.displayvalue
                      == this.props.updateData.ReportData[0].frequencyvalue,
                  );
                  this.setState({
                    selectedMonth,
                    freqValue: selectedMonth.displayvalue,
                  });
                },
              );
              break;
            default:
              this.setState({
                daily: false,
                weekly: false,
                monthly: false,
                quaterly: false,
                annualy: false,
              });
          }
        },
      );
    }
  }

  componentWillReceiveProps(props) {
    if (!this.state.freq && this.props.updateId != null) {
      console.log("this.state.freq: ", this.state.freq);
      console.log("this.props.updateData: ", props, this.props.updateData);
      const freq = props.FrequencyType.find(
        (x) =>
          x.displayvalue == this.props.updateData.ReportData[0].frequencytypeid,
      );
      this.setState({
        freq,
      });
    }
  }

  freqOnChange(val) {
    this.setState({
      showTime: false,
      selectTime: "",
      selectedMonth: "",
      selectedDay: "",
      selectedWeek: "",
    });
    switch (val.displayvalue) {
      case 1:
        this.setState(
          {
            daily: true,
            weekly: false,
            monthly: false,
            quaterly: false,
            annualy: false,
            freq: val,
          },
          () => {
            this.setState({ showTime: true });
          },
        );
        break;
      case 2:
        this.setState({
          daily: false,
          weekly: true,
          monthly: false,
          quaterly: false,
          annualy: false,
          freq: val,
        });
        break;

      case 3:
        this.setState({
          daily: false,
          weekly: false,
          monthly: true,
          quaterly: false,
          annualy: false,
          freq: val,
        });
        break;
      case 4:
        this.setState({
          daily: false,
          weekly: false,
          monthly: false,
          quaterly: true,
          annualy: false,
          freq: val,
        });
        break;
      case 6:
        this.setState({
          daily: false,
          weekly: false,
          monthly: false,
          quaterly: false,
          annualy: true,
          freq: val,
        });
        break;
      default:
        this.setState({
          daily: false,
          weekly: false,
          monthly: false,
          quaterly: false,
          annualy: false,
          freq: val,
        });
    }
  }

  dayOnChange(val) {
    this.setState({ selectedDay: val, freqValue: val.displayvalue }, () => {
      this.showTime();
    });
  }

  weekOnChange(val) {
    this.setState({ selectedWeek: val, freqValue: val.displayvalue }, () => {
      this.showTime();
    });
  }

  monthOnChange(val) {
    this.setState({ selectedMonth: val, freqValue: val.displayvalue }, () => {
      this.showTime();
    });
  }

  showTime() {
    this.setState({ showTime: true });
  }

  timeOnSelect(val) {
    this.setState({ selectTime: val });
  }

  getTimeComp = () =>
    (this.state.showTime ? (
      <div className="inner-wrapper opaque autoreport-time">
        <div className="margin-bottom-20">
          <p className="add-label-active">
            <FormattedMessage id="LbTime" defaultMessage="Time" />
          </p>
          <TextField
            id=""
            margin="dense"
            variant="outlined"
            type="time"
            className="attendancetimeinput width100"
            onChange={(e) => this.timeOnSelect(e.target.value)}
            // change={this.timeOnSelect.bind(this)}
            value={this.state.selectTime}
            // error={fromtime && isIntimeBeforeOuttime({ intime: moment().format("HH:mm:ss"), outtime: fromtime })}
          />
        </div>
      </div>
    ) : null);

  render() {
    const { classes } = this.props;
    const language = this.props.Language.reportrobo;

    return (
      <IntlProvider locale="en" messages={language}>
        {/* <div className="innerwrapper" >
                    <div className={classes.root}> */}
        {/* <Grid container>
                            <Grid item xs={12} md={6} sm={6} > */}
        {/* <Grid container> */}
        <div>
          <SendReport
            {...this.props}
            permissions={this.props.permissions}
            // reportcatagoryid={this.props.reportcatagoryid}
            // reporttypeid={this.props.reporttypeid}
            // generationtypeid={this.props.generationtypeid}
            frequencytypeid={get(this.state, "freq.displayvalue", "")}
            frequencyvalue={this.state.freqValue}
            scheduledtime={this.state.selectTime}
            clearReportType={() => this.props.clearReportType()}
            saveReportFlag={this.props.saveReportFlag}
            _setState={this.props._setState}
          />
          <p className="input-form-label" />
          <div className="inner-wrapper opaque">
            <div className="form-group">
              <p className="add-label-active">
                Set your report delivery preference
              </p>
              <Select
                class="form-control"
                autofocus
                placeholder="Select Frequency"
                options={this.props.FrequencyType}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                onChange={this.freqOnChange.bind(this)}
                value={this.state.freq}
              />
            </div>
          </div>
          {/* <div className="inner-wrapper opaque">
                                            <div className="form-group">
                                                <p className="add-label-active">
                                                    <FormattedMessage id="LbFrequency" defaultMessage="Frequency" /></p>
                                                    <Select class="form-control" autofocus placeholder="Select Frequency"></Select>
                                            </div>
                                        </div> */}
          {this.state.daily ? (
            <div className="">
              {this.getTimeComp()}
              <span className="floatleft">
                <img src={ReportRoboImg} />
              </span>
              <span className="robo-alert add-label-active">
                <FormattedMessage
                  id="__LbDaily"
                  defaultMessage="I will send this report to you daily. It will cover data from previous day "
                />
              </span>
            </div>
          ) : null}
          {this.state.weekly ? (
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="add-label-active">
                  <FormattedMessage
                    id="LbDayoftheWeek"
                    defaultMessage="Day of the Week"
                  />
                </p>
                <Select
                  class="form-control"
                  autofocus
                  placeholder="Select Day of Week"
                  options={this.state.weekList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.weekOnChange.bind(this)}
                  value={this.state.selectedWeek}
                />
              </div>
              {this.getTimeComp()}
              {this.state.selectedWeek ? (
                <div className="">
                  <span className="floatleft">
                    <img src={ReportRoboImg} />
                  </span>
                  <span className="robo-alert add-label-active">
                    <FormattedMessage
                      id="__LbWeekly"
                      defaultMessage="I will send this report to you every week on "
                    />
                    {this.state.selectedWeek.displayname}
                  </span>
                </div>
              ) : null}
            </div>
          ) : null}
          {this.state.monthly ? (
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="add-label-active">
                  <FormattedMessage
                    id="LbDateofMonth"
                    defaultMessage="Date of Month"
                  />
                </p>
                <Select
                  class="form-control"
                  autofocus
                  placeholder="Select Date of Month"
                  options={this.state.dayList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.dayOnChange.bind(this)}
                  value={this.state.selectedDay}
                />
              </div>

              {this.getTimeComp()}
              {this.state.selectedDay ? (
                <div className="">
                  <div className="margin-bottom-30 padding-bottom-10">
                    <span className="floatleft">
                      <img src={ReportRoboImg} />
                    </span>
                    <span className="robo-alert add-label-active ">
                      <FormattedMessage
                        id="__LbMonthly"
                        defaultMessage="I will send this report to you every month on the "
                      />
                      {this.state.selectedDay.displayname} <br />
                    </span>
                  </div>
                  {this.state.selectedDay.displayvalue == 30
                  || this.state.selectedDay.displayvalue == 31 ? (
                    <div className="margin-top-30 padding-top-10">
                      <span className="floatleft">
                        <img src={ReportRoboImg} />
                      </span>
                      <span className="robo-alert add-label-active">
                        <FormattedMessage
                          id="__LbNote"
                          defaultMessage="Report will be sent last day of the month "
                        />
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.selectedDay.displayvalue == 29 ? (
                    <div className="margin-top-30 padding-top-10">
                      <span className="floatleft">
                        <img src={ReportRoboImg} />
                      </span>
                      <span className="robo-alert add-label-active">
                        <FormattedMessage
                          id="__LbNoteFeb"
                          defaultMessage="NOTE: Report will be sent last day of February "
                        />
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : null}
            </div>
          ) : null}
          {this.state.quaterly || this.state.annualy ? (
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="add-label-active">
                  <FormattedMessage
                    id="LbMonthoftheYear"
                    defaultMessage="Month of the Year"
                  />
                </p>
                <Select
                  class="form-control"
                  autofocus
                  placeholder="Select Month of Year"
                  options={this.state.monthList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.monthOnChange.bind(this)}
                  value={this.state.selectedMonth}
                />
              </div>
              {this.getTimeComp()}
              {this.state.selectedMonth ? (
                <div className="">
                  <span className="floatleft">
                    <img src={ReportRoboImg} />
                  </span>
                  <span className="robo-alert add-label-active">
                    <FormattedMessage
                      id="__LbYearly"
                      defaultMessage="I will send this report to you every "
                    />
                    {this.state.quaterly
                      ? "quarter"
                      : this.state.annualy
                      ? "year"
                      : ""}{" "}
                    starting from 1st of {this.state.selectedMonth.displayname}
                  </span>
                </div>
              ) : null}
            </div>
          ) : null}
          {/* {this.state.showTime ?  : null} */}
          {/* {this.getTimeComp()} */}

          {/* {this.state.selectTime ? (
            <SendReport
              {...this.props}
              permissions={this.props.permissions}
              // reportcatagoryid={this.props.reportcatagoryid}
              // reporttypeid={this.props.reporttypeid}
              // generationtypeid={this.props.generationtypeid}
              frequencytypeid={this.state.freq.displayvalue}
              frequencyvalue={this.state.freqValue}
              scheduledtime={this.state.selectTime}
              clearReportType={() => this.props.clearReportType()}
            />
          ) : null} */}
          {/* <div>
                    </div> */}
        </div>
        {/* </Grid> */}
        {/* </Grid>
                        </Grid> */}
        {/* </div>
                </div> */}
      </IntlProvider>
    );
  }
}

AutoReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(AutoReport)));
